import OneNoteService from "@/services/onenote.service";
import MicrosoftService from "@/services/microsoft.service";


export const onenote = {
    namespaced: true,

    state: {
        notebooks: [],
        sections: [],
        pages: [],
        notes: [],
        loading: false,
        error: null,
        microsoftConnected: false
    },
    getters: {
        notebooks: state => state.notebooks,
        sections: state => state.sections,
        pages: state => state.pages,

        loading: state => state.loading,
        error: state => state.error,

        microsoftConnected: state =>
            state.microsoftConnected
    },
    mutations: {
        SET_MICROSOFT_CONNECTED(state, value) {
            state.microsoftConnected = value;
        },
        SET_NOTEBOOKS(state, value) {
            state.notebooks = value;
        },
        SET_SECTIONS(state, value) {
            state.sections = value;
        },
        SET_PAGES(state, value) {
            state.pages = value;
        },
        SET_NOTES(state, value) {
            state.notes = value;
        },
        SET_LOADING(state, value) {
            state.loading = value;
        },
        SET_ERROR(state, value) {
            state.error = value;
        }
    },
    actions: {
        async connectMicrosoft() {
            try {
                const response = await MicrosoftService.login();
                if (response?.url) {
                    window.location.href = response.url;
                }

                return response;
            }
            catch (error) {
                console.error("Microsoft connect error:", error);
                throw error;
            }
        },
        async checkConnection({ commit }) {
            try {
                const response = await OneNoteService.getConnectionStatus();
                commit("SET_MICROSOFT_CONNECTED", response.connected);

                return response.connected;
            }
            catch (error) {
                console.error("Microsoft connection check error:", error);
                commit("SET_MICROSOFT_CONNECTED", false);

                return false;
            }
        },
        async loadNotebooks({ commit, state }) {
            commit("SET_LOADING", true);
            commit("SET_ERROR", null);

            try {
                const response = await OneNoteService.getNotebooks();
                commit("SET_NOTEBOOKS", response.value || []);
                commit("SET_MICROSOFT_CONNECTED", true);

                return response;
            }
            catch (error) {
                console.error("[VUEX] getNotebooks error:",
                    error.response?.status,
                    error.response?.data
                );
                if (error.response?.status === 409 && error.response?.data?.code === "MICROSOFT_REAUTH_REQUIRED") {
                    commit("SET_MICROSOFT_CONNECTED", false);
                    commit("SET_NOTEBOOKS", []);
                    commit("SET_ERROR", null);

                    return null;
                }
                if (error.response?.status === 404) {
                    commit("SET_MICROSOFT_CONNECTED", false);
                    commit("SET_NOTEBOOKS", []);
                    commit("SET_ERROR", null);

                    return null;
                }

                commit("SET_ERROR", error.response?.data?.message || "OneNote 노트북을 불러오지 못했습니다.");

                return null;
            }
            finally {
                commit("SET_LOADING", false);
            }
        },
        async loadSections({ commit }, notebookId ) {
            commit("SET_LOADING", true);
            commit("SET_ERROR", null);

            try {
                const response = await OneNoteService.getSections(notebookId);
                commit("SET_SECTIONS", response.value || []);

                return response;
            }
            catch (error) {
                console.error("OneNote sections load error:", error);
                commit("SET_ERROR", error.response?.data?.message || "OneNote 섹션을 불러오지 못했습니다.");

                return null;
            }
            finally {
                commit("SET_LOADING", false);
            }
        },
        async loadPages( { commit }, sectionId ) {
            commit("SET_LOADING", true);
            commit("SET_ERROR", null);

            try {
                const response = await OneNoteService.getPages(sectionId);
                commit("SET_PAGES", response.value || []);

                return response;
            }
            catch (error) {
                console.error("OneNote pages load error:", error);
                commit("SET_ERROR", error.response?.data?.message || "OneNote 페이지를 불러오지 못했습니다.");

                return null;
            }
            finally {
                commit("SET_LOADING", false);
            }
        },
        async loadStickyNotes({ commit }) {
            commit("SET_LOADING", true);
            commit("SET_ERROR", null);

            try {
                const response = await OneNoteService.getNotes();
                commit("SET_NOTES", response.value || []);

                return response;
            } catch (error) {
                console.error("[VUEX] Sticky Notes error:", error.response?.data || error);
                commit("SET_ERROR", error.response?.data?.message || "빠른 노트를 불러오지 못했습니다.");

                return null;
            } finally {
                commit("SET_LOADING", false);
            }
        },
        async updateStickyNote({ dispatch }, { noteId, content }) {
            try {
                await OneNoteService.updateStickyNote({ noteId, content });
                await dispatch("loadStickyNotes");
            } catch (error) {
                console.error("Sticky Note 수정 실패:", error);
                throw error;
            }
        },
        async createStickyNote(
            { dispatch, commit },
            { subject, content }
        ) {
            try {
                const response =
                    await OneNoteService.createStickyNote({
                        subject,
                        content
                    });

                await dispatch("loadStickyNotes");

                return response;

            } catch (error) {
                console.error(
                    "[VUEX] Sticky Note 생성 실패:",
                    error.response?.data || error
                );

                commit(
                    "SET_ERROR",
                    error.response?.data?.message ||
                    "빠른 노트 생성에 실패했습니다."
                );

                return null;
            }
        },

        async deleteStickyNote(
            { dispatch, commit },
            noteId
        ) {
            try {
                await OneNoteService.deleteStickyNote(noteId);

                await dispatch("loadStickyNotes");

                return true;

            } catch (error) {
                console.error(
                    "[VUEX] Sticky Note 삭제 실패:",
                    error.response?.data || error
                );

                commit(
                    "SET_ERROR",
                    error.response?.data?.message ||
                    "빠른 노트 삭제에 실패했습니다."
                );

                return false;
            }
        },
    }
};